import axiosInstance from './AxiosInstance'; // Reuse the centralized Axios instance

const SCACService = {
  fetchSCACs: async (page, pageSize, sortBy, order, searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", // Add searchTerm in the query object
    };
  
    try {
      const response = await axiosInstance.get('/scac', {
        params: queryObj,  // Send the query object as parameters
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching SCACs:', error);
      throw error;
    }
  },
  

  createSCAC: async (data) => {
    try {
      const response = await axiosInstance.post('/scac', data);
      return response.data;
    } catch (error) {
      console.error('Error creating SCAC:', error);
      throw error;
    }
  },

  updateSCAC: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/scac/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating SCAC with ID ${id}:`, error);
      throw error;
    }
  },

  deleteSCAC: async (id) => {
    try {
      const response = await axiosInstance.delete(`/scac/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting SCAC with ID ${id}:`, error);
      throw error;
    }
  },
};

export default SCACService;
